// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { IconSparkles } from "@tabler/icons-react";

import { useCrosswordStore } from "@/store";

export function HintsButton() {
  const options = useCrosswordStore.use.options();
  const crossword = useCrosswordStore.use.crossword();
  const setGiraffeMood = useCrosswordStore.use.setGiraffeMood();
  const revealHint = useCrosswordStore.use.revealHint();
  const isCrosswordCompleted = useCrosswordStore.use.isCrosswordCompleted();
  const isChecked = useCrosswordStore.use.isChecked();

  const handleClick = () => {
    if (!crossword) {
      return;
    }

    setGiraffeMood("wonder");
    revealHint();
  };

  return (
    <button
      className="flex h-10 cursor-pointer items-center gap-1 rounded-[20px] bg-[#329DA7] px-3 text-white hover:bg-[#228690] disabled:cursor-default disabled:bg-[#42576ec4]"
      onClick={handleClick}
      disabled={options.hints <= 0 || isCrosswordCompleted() || isChecked}
      aria-label={
        options.hints > 0
          ? t("Get a hint, {{count}} hints remaining", { count: options.hints })
          : t("No hints available")
      }
    >
      <span>{t("Hint")}</span>
      {options.hints > 0 && `(${options.hints})`}
      <IconSparkles size={18} aria-hidden="true" />
    </button>
  );
}
